export default __webpack_public_path__ + "static/media/sports2.5c0cf0a5.png";